import { styled } from '@mui/material/styles';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const TableStyled = styled(Table, {
  name: 'TableStyled',
  shouldForwardProp: (propName: string) => propName !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  tableLayout: 'fixed',
  ...(compact && {
    '& .MuiTableCell-root': {
      padding: theme.spacing(1, 2),
    },
  }),
}));

const TableHeadStyled = styled(TableHead, {
  name: 'TableHeadStyled',
})(() => ({
  textTransform: 'none',
}));

const TableBodyStyled = styled(TableBody, {
  name: 'TableBodyStyled',
})(() => ({}));

const TableRowStyled = styled(TableRow, {
  name: 'TableRowStyled',
})(() => ({}));

const TableCellStyled = styled(TableCell, {
  name: 'TableCellStyled',
})(() => ({}));

const PaperStyled = styled(Paper, {
  name: 'PaperStyled',
})(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(2),
}));

export {
  DeleteIcon,
  AddIcon,
  ExpandMoreIcon,
  ExpandLessIcon,
  TableStyled,
  TableHeadStyled,
  TableBodyStyled,
  TableRowStyled,
  TableCellStyled,
  PaperStyled,
};
